export const TS_Form_DefaultRenderers = {};
//# sourceMappingURL=consts.js.map